import { render, staticRenderFns } from "./TipoEvento.vue?vue&type=template&id=1582a0ec"
import script from "./TipoEvento.vue?vue&type=script&lang=js"
export * from "./TipoEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports